const t = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Unpin Left Icon</title><desc>A picture depicting a crossed-out left-pointed pin.</desc><path d="M11.8 14.1l-5.1 5.1H5.3v-1.4l5.1-5.1L2 4.3 3.3 3l18 18-1.3 1.2-8.2-8.1zm4-.5l-5-5h.7L15.1 5V2.2l7.1 7.1h-2.8l-3.5 3.5-.1.8z"/></svg>';
export {
  t as default
};
